import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="spinner-container" role="status" aria-label="Loading">
      <div className="spinner" />
    </div>
  );
}
